import * as React from "react";
import { createRoot } from "react-dom/client";
import SearchProviderTool from "./search-providers/SearchProviderTool";
import type {
  ProviderData,
  SearchProviderWindow,
} from "./search-providers/SearchProvider.types.d.ts";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ErrorMessage from "./Components/ErrorMessage";

declare var window: SearchProviderWindow;

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById(
    "search-providers"
  ) as HTMLDivElement;

  if (container) {
    const data: ProviderData = window.providerData;

    const root = createRoot(container);

    const router = createBrowserRouter([
      {
        path: "*",
        element: <SearchProviderTool {...data} />,
        errorElement: (
          <ErrorMessage message="Oops! There was an error trying to render this page. Please reload the page." />
        ),
      },
    ]);

    root.render(
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    );
  }
});
export { ProviderData };
